// 通用处理报告跳转链接
export const getReportInfo = (item: any, name_en: string) => {
  const newItem = { ...item };
  if (newItem.type === '0') {
    newItem.pathname = `/opinion/Report/${name_en?.replaceAll(/\s/gi, '')}`;
    newItem.actualPath = `${newItem.pathname}?game_code=${newItem.report_id}&content_url=${newItem.report_url}`;
  }
  if (newItem.type === '3') {
    // Preset 类型
    newItem.pathname = `/opinion/Preset/${encodeURIComponent(name_en)}`;
    newItem.actualPath = newItem.pathname;
  }
  // gpt_report： tab形态的gpt report  |   gpt : gpt auto report
  if (newItem.type === '4') {
    if (newItem.business_type === 'gpt') {
      // 通用Gpt模式
      newItem.pathname = `/opinion/gpt/GPT%20Auto%20Report?name=${encodeURIComponent(
        name_en,
      )}`;
    } else if (newItem.business_type === 'gpt_report') {
      newItem.pathname = `/opinion/CustomizeReport/${encodeURIComponent(
        name_en,
      )}/${newItem.report_id}`;
    } else if (newItem.business_type === 'spotlight') {
      newItem.pathname = `/opinion/CustomizeReport/${encodeURIComponent(
        name_en,
      )}/${newItem.id}`;
    } else {
      const kind = newItem?.assembly_params?.kind || 3;
      const menuId = newItem?.id;
      const hasReportId = !!newItem?.report_id;
      newItem.pathname = `/opinion/gptReport/${menuId}/${kind}/${hasReportId}`;
    }
    newItem.actualPath = newItem.pathname;
  }
  if (newItem.type === '5') {
    // Preset 类型
    newItem.pathname = `/opinion/Insights?name=${encodeURIComponent(name_en)}`;
    newItem.actualPath = newItem.pathname;
  }
  if (newItem.type === '6') {
    // pdf 路由
    newItem.pathname = `/opinion/PDFReport/${newItem.id
      }?pdfUrl=${encodeURIComponent(newItem.report_url)}`;
    newItem.actualPath = newItem.pathname;
  }
  if (newItem.type === '7') {
    // looker 路由
    newItem.pathname = `/opinion/Looker/${newItem.id}`;
    newItem.actualPath = newItem.pathname;
  }
  if (newItem.type === '8') {
    // authPath 鉴权报表路由
    newItem.pathname = `/opinion/authPath/report/${encodeURIComponent(name_en)}`;
    newItem.actualPath = newItem.pathname;
  }
  if (newItem.type === '9') {
    // aigallery report 路由
    newItem.pathname = `/opinion/AIGalleryReport/${newItem.id}?path=${encodeURIComponent(newItem.report_url)}`;
    newItem.actualPath = newItem.pathname;
  }
  return newItem;
};
